import "core-js/modules/es6.function.name";
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  size: function size(state) {
    return state.app.size;
  },
  device: function device(state) {
    return state.app.device;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  introduction: function introduction(state) {
    return state.user.introduction;
  },
  userPermission: function userPermission(state) {
    return state.user.userPermission;
  },
  isSuperman: function isSuperman(state) {
    return state.user.isSuperman;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  rolesViews: function rolesViews(state) {
    return state.user.rolesViews;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  errorLogs: function errorLogs(state) {
    return state.errorLog.logs;
  },
  asyncRoutes: function asyncRoutes(state) {
    return state.permission.asyncRoutes;
  },
  account: function account(state) {
    return state.user.account;
  }
};
export default getters;